<h1>{{ this.currentTitle }}</h1>

<div [nbSpinner]="loading()"
     nbSpinnerStatus="danger"
     nbSpinnerSize="large"
     nbSpinnerMessage="">
  <div>
    <button (click)="confirmAccount()" nbButton fullWidth status="primary">{{ 'validate_account.confirm' | translate }}</button>
  </div>
</div>

